import * as React from 'react';
import { connect } from 'react-redux';
import { fetchSeller, editSeller, fetchProvinciaLocalidadByCodigoPostal, clearLocalidadProvincia } from '../../actions/sellersActions';
import Cleave from 'cleave.js/react';
import Select from 'react-select';
import { DropDownArrow, profileSelectStyle } from '../../template/CustomStyle';
import PropTypes from 'prop-types';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

class DatosContactos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            codigoPostalAnterior: null,
        };
        this.domilicioInputRef = React.createRef();
    };

    componentDidMount() {
        if (this.domilicioInputRef.current) {
            this.domilicioInputRef.current.focus();
        }

        const { seller } = this.props;

        //crea un seller
        if (!seller?.id) {
            this.props.clearLocalidadProvincia();
        }
    }

    myChangeHandler = (event) => {
        const { name, value } = event.target;

        this.setState({
            didEdit: true
        });

        let seller = { ...this.props.seller };

        if (name === 'codigoPostal') {
            const codigoPostalStr = String(value);

            if (codigoPostalStr !== this.state.codigoPostalAnterior) {

                // Limpiamos los campos y el store
                seller.provincia = '';
                seller.localidad = '';
                this.props.editSeller(seller);
                this.props.clearLocalidadProvincia();

                this.setState({ codigoPostalAnterior: codigoPostalStr });

                if (codigoPostalStr.length === 4) {
                    const request = { codPostal: codigoPostalStr };
                    this.props.fetchProvinciaLocalidadByCodigoPostal(request);
                }

                seller[name] = value;
                this.props.editSeller(seller);

                return;
            }
        }

        seller[name] = value;
        this.props.editSeller(seller);
    };

    render() {
        let { seller, localidadProvincia } = this.props;

        const provinciasOptions = localidadProvincia?.nombreProvincia?.map(prov => ({
            label: prov,
            value: prov
        })) || [];

        const provinciaSeleccionada = provinciasOptions.find(
            option => option.value === seller.provincia
        ) || (seller.provincia ? { label: seller.provincia, value: seller.provincia } : null);

        const localidadesOptions = localidadProvincia?.localidades?.map(loc => ({
            label: loc,
            value: loc
        })) || [];

        const localidadSeleccionada = localidadesOptions.find(
            option => option.value === seller.localidad
        ) || (seller.localidad ? { label: seller.localidad, value: seller.localidad } : null);

        return (
            <div className="tab-pane active" name="datos" id="home2" role="tabpanel">
                <section className="profile-section">
                    <header className="profile-section__head">
                        <span className="profile-section__icon" aria-hidden="true"><i className="ti-location-pin" /></span>
                        <div>
                            <h5 className="profile-section__title">Domicilio</h5>
                            <p className="profile-section__hint">El código postal completa localidad y provincia.</p>
                        </div>
                    </header>
                    <div className="row g-3">
                        <div className="form-group col-md-8">
                            <label htmlFor="calle">Calle</label>
                            <input
                                id="calle"
                                type="text"
                                className="form-control"
                                value={seller.domicilio || ""}
                                onChange={this.myChangeHandler}
                                name="domicilio"
                                ref={this.domilicioInputRef}
                            />
                        </div>

                        <div className="form-group col-md-4">
                            <label htmlFor="altura">Altura</label>
                            <Cleave
                                id="altura"
                                className="form-control"
                                name="numeroDomicilio"
                                value={seller.numeroDomicilio || ""}
                                options={{ blocks: [5], numericOnly: true }}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="form-group col-md-4">
                            <label htmlFor="codigoPostal">Código Postal </label>
                            <Cleave
                                id="codigoPostal"
                                className="form-control"
                                name="codigoPostal"
                                value={seller.codigoPostal || ""}
                                options={{ blocks: [4], numericOnly: true }}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="form-group col-md-4">
                            <label htmlFor="localidad">Localidad</label>
                            <Select
                                id="localidad"
                                name="localidad"
                                value={localidadSeleccionada ?? seller.localidad}
                                options={localidadesOptions}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                onChange={(selectedOption) => this.myChangeHandler({ target: { name: 'localidad', value: selectedOption.value } })}
                                styles={profileSelectStyle}
                                menuPortalTarget={document.body}
                                placeholder="Seleccione una localidad"
                            />
                        </div>

                        <div className="form-group col-md-4">
                            <label htmlFor="provincia">Provincia</label>
                            <Select
                                id="provincia"
                                name="provincia"
                                value={provinciaSeleccionada ?? seller.provincia}
                                options={provinciasOptions}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                onChange={(selectedOption) => this.myChangeHandler({ target: { name: 'provincia', value: selectedOption.value } })}
                                styles={profileSelectStyle}
                                placeholder="Seleccione una provincia"
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                </section>

                <section className="profile-section">
                    <header className="profile-section__head">
                        <span className="profile-section__icon" aria-hidden="true"><i className="ti-headphone-alt" /></span>
                        <div>
                            <h5 className="profile-section__title">Teléfono</h5>
                            <p className="profile-section__hint">Contacto directo de la tienda.</p>
                        </div>
                    </header>
                    <div className="row g-3">
                        <div className="form-group col-md-6">
                            <label htmlFor="telefono">Teléfono</label>
                            <Cleave
                                id="telefono"
                                className="form-control"
                                name="telefono"
                                value={seller.telefono || ""}
                                options={{ blocks: [10], numericOnly: true }}
                                onChange={this.myChangeHandler}
                            />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
DatosContactos.propTypes = {
    // Redux props
    seller: PropTypes.shape({
        id: PropTypes.number,
        provincia: PropTypes.string,
        localidad: PropTypes.string,
        domicilio: PropTypes.string,
        numeroDomicilio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        codigoPostal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        telefono: PropTypes.string,
    }),
    localidadProvincia: PropTypes.oneOfType([PropTypes.shape({
        nombreProvincia: PropTypes.array,
        localidades: PropTypes.array,
    }), PropTypes.array]),
    // Actions props
    clearLocalidadProvincia: PropTypes.func,
    fetchProvinciaLocalidadByCodigoPostal: PropTypes.func,
    editSeller: PropTypes.func,
}

const mapStateToProps = state => ({
    seller: selectSellerMerged(state),
    tipoUsuario: state.general.tipoUsuario,
    localidadProvincia: state.sellers.provinciasLocalidades ?? [],
});

export default connect(mapStateToProps, { fetchSeller, editSeller, fetchProvinciaLocalidadByCodigoPostal, clearLocalidadProvincia })(DatosContactos);